var _excluded = ["children", "classes", "as"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "@xo-union/tk-css-grid/lib/styles.css";
var TopLevelContainer = function TopLevelContainer(_ref) {
  var children = _ref.children,
    classesProp = _ref.classes,
    ComponentToRender = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: classes['top-level-container']
  }, props), children);
};
process.env.NODE_ENV !== "production" ? TopLevelContainer.propTypes = {
  children: PropTypes.node,
  /**
   * Class dependencies
   */
  classes: classesPropType(['top-level-container']),
  /**
   * Component to render
   */
  as: PropTypes.elementType
} : void 0;
TopLevelContainer.defaultProps = {
  as: 'div'
};
export default TopLevelContainer;